import { AnalysisSummaryDTO } from "@models/platform-analysis/entities/steps/summary";
import { AnalysisStep } from "@models/platform-analysis/enums/step";
import {
  AnalysisCommentFieldPath,
  CommentFeatureMatchColWidthPercent,
  CommentProductColWidthPercent,
  CommentSettingFieldPath,
} from "@pages/platform-analysis-v2/_id/constants";
import { FieldPath } from "react-hook-form";

export const getCommentColWidth = (countStep: number): number => {
  return (
    (100 -
      (CommentProductColWidthPercent + CommentFeatureMatchColWidthPercent)) /
    countStep
  );
};

export const getCommentFieldPath = (
  basePath: FieldPath<AnalysisSummaryDTO>,
  step: AnalysisStep,
): FieldPath<AnalysisSummaryDTO> =>
  `${basePath}.${AnalysisCommentFieldPath[step]}` as FieldPath<AnalysisSummaryDTO>;

export const getCommentSettingFieldPath = (
  basePath: FieldPath<AnalysisSummaryDTO>,
  step: AnalysisStep,
): FieldPath<AnalysisSummaryDTO> =>
  `${basePath}.${CommentSettingFieldPath[step]}` as FieldPath<AnalysisSummaryDTO>;
